import { FC } from 'react';

import Button from 'src/presentations/components/atom/button';
import IconReceipt from 'src/assets/images/icons/receipt-alt.svg';
import { useGetFileUrl } from 'src/use-cases/invoice/useInvoices';

import { UCTInputUploadDocument } from '../../UploadDocument/Input';
import { UCTApprovalsProps } from './types';

export const UCTUploadDocument: FC<UCTApprovalsProps> = (props) => {
  const { invoiceSummary } = props;
  const { refetch } = useGetFileUrl(invoiceSummary?.id);

  const onShowOriginalInvoice = async () => {
    const result = await refetch();
    if (result?.data) {
      window.open(result?.data, '_blank');
    }
  };

  return (
    <>
      <div className='px-24 mt-24'>
        <h3 className='text-14 xl:text-16 font-bold mb-12'>Step 1: Check the original invoice document for Approvals</h3>

        <div className='flex'>
          <Button variant='neutral_outline' onClick={onShowOriginalInvoice}>
            <div className='flex items-center gap-12'>
              <img src={IconReceipt} alt='' />
              Original Invoice
            </div>
          </Button>
        </div>
      </div>

      <div className='pt-24 px-24 mt-24 border-t border-dashed border-neutral-20'>
        <h3 className='text-14 xl:text-16 font-bold mb-12'>Step 2: Upload missing or additional Approvals</h3>

        <UCTInputUploadDocument
          invoiceSummary={invoiceSummary}
          attachmentType='APPROVAL'
          isPreview={invoiceSummary?.status === 'APPROVED' || invoiceSummary?.status === 'REJECTED'}
        />
      </div>
    </>
  );
};
